export default {
  state: {
    url: '',
    ramal: '',
    macAddress: '',
    status: 0
  },

  mutations: {
    setPabxStatus: (state, status) => {
      state.pabx.status = status
    },

    setPabx: (state, pabx) => {
      state.pabx = pabx
    },

    setPabxMacAddress: (state, macAddress) => {
      state.pabx.macAddress = macAddress
    },

    setPabxRamal: (state, ramal) => {
      state.pabx.ramal = ramal
    }
  },

  getters: {
    getPabxStatus: state => state.pabx.status
  }

}



// WEBPACK FOOTER //
// ./src/store/storePabx.js